//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { formatTime } from '../../../components/helpers.js'
import { createFieldConfig } from '../../../components/QSelectUtils.js'
import { axiosGet } from '../../../axios/axios.js'
import Table from '../../../components/Table/Table.vue'
import TableCellObject from '../../../components/Table/TableCellObject.vue'

export default {
  name: 'VehicleProvisionRoutePointsList',
  components: {
    Table,
    TableCellObject
  },
  props: {
    request: {
      type: Object,
      default: () => {
        return {}
      }
    },
    requestProperties: {
      type: Object,
      default: () => {
        return {}
      }
    },
    routePoints: {
      type: Array,
      default: () => {
        return []
      }
    },
    interval: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data: function () {
    return {
      projectsFieldConfig: createFieldConfig({ allRecordsFn: this.getProjects }),

      pagination: {
        rowsPerPage: 0,
        page: 1
      },
      columns: [
        {
          name: 'number',
          label: '№',
          align: 'left',
          field: 'number',
          defaultWidth: 35
        },
        {
          name: 'sourcedAddressName',
          label: 'Объект',
          align: 'left',
          field: 'sourcedAddress',
          columnFormat: 'object'
        },
        {
          name: 'sourcedAddressValue',
          label: 'Адрес',
          align: 'left',
          field: 'sourcedAddress',
          format: value => value && value.value || ''
        },
        {
          name: 'projects',
          label: 'Проект',
          align: 'left',
          field: 'projects',
          columnFormat: 'objects',
          columnObjectType: 'project'
        },
        {
          name: 'plannedStartTime',
          label: 'Плановое время подачи',
          align: 'left',
          field: 'plannedStartTime',
          format: formatTime,
          defaultWidth: 130
        },
        {
          name: 'plannedEndTime',
          label: 'Плановое время отбытия',
          align: 'left',
          field: 'plannedEndTime',
          format: formatTime,
          defaultWidth: 130
        },
        {
          name: 'actualStartTime',
          label: 'Фактическое время подачи',
          align: 'left',
          field: 'actualStartTime',
          format: formatTime,
          defaultWidth: 130
        },
        {
          name: 'actualEndTime',
          label: 'Фактическое время отбытия',
          align: 'left',
          field: 'actualEndTime',
          format: formatTime,
          defaultWidth: 130
        }
      ]
    }
  },
  computed: {
    filteredRoutePoints: function () {
      return this.routePoints.filter(p => !p.removed)
    },
    selectedRow: function () {
      return this.filteredRoutePoints.find(p => p.isChecked)
    },
    readonly: function () {
      return this.requestProperties.routePoints.readonly
    },
    readonlyFirstRoutePointDelivery: function () {
      return this.requestProperties.routePoints.accessProps && this.requestProperties.routePoints.accessProps.firstRoutePointFixed
    },
    actualTimesReadonly: function () {
      return this.requestProperties.routePoints.accessProps && this.requestProperties.routePoints.accessProps.actualTimesReadonly
    }
  },
  methods: {
    disableOnUpPosition: function (row) {
      if (this.readonly) {
        return true
      }
      const index = this.filteredRoutePoints.findIndex(routePoint => routePoint.id === row.id)
      if (index === 0) {
        return true
      }
      if (this.readonlyFirstRoutePointDelivery && index === 1) {
        return true
      }
    },
    disableOnDownPosition: function (row) {
      if (this.readonly) {
        return true
      }
      const index = this.filteredRoutePoints.findIndex(routePoint => routePoint.id === row.id)
      if (index === this.filteredRoutePoints.length - 1) {
        return true
      }
      if (this.readonlyFirstRoutePointDelivery && index === 0) {
        return true
      }
    },
    disableDelete: function (row) {
      if (this.readonly) {
        return true
      }
      const index = this.filteredRoutePoints.findIndex(routePoint => routePoint.id === row.id)
      if (this.readonlyFirstRoutePointDelivery && index === 0) {
        return true
      }
    },
    onDeleteRecord: function (row) {
      const index = this.filteredRoutePoints.indexOf(row)
      if (index !== -1) {
        this.$set(this.filteredRoutePoints[index], 'removed', true)

        if (index === 0) {
          this.setRoutePropertiesFromRequest(this.filteredRoutePoints[0])
        }
        for (let i = index; i < this.filteredRoutePoints.length; i++) {
          this.filteredRoutePoints[i].number = i + 1
          this.filteredRoutePoints[i].edited = true
        }
      }
    },
    onAddRecord: function (place = 'end') {
      let defaultProjects = null
      let selectedRowIndex

      if (place === 'before') {
        if (!this.selectedRow) {
          return
        }
        selectedRowIndex = this.filteredRoutePoints.findIndex(routePoint => routePoint.id === this.selectedRow.id)
        if (selectedRowIndex !== -1) {
          const prevPoint = this.filteredRoutePoints[selectedRowIndex - 1]
          if (prevPoint && prevPoint.projects && prevPoint.projects.length) {
            defaultProjects = prevPoint.projects
          } else {
            defaultProjects = this.selectedRow.projects
          }
        }
      } else {
        const prevPoint = this.filteredRoutePoints[this.filteredRoutePoints.length - 1]
        if (prevPoint) {
          defaultProjects = prevPoint.projects
        }
      }

      this.$d_ask({
        callback: (data, action) => {
          if (action === 'yes') {
            data.added = true
            if (place === 'end') {
              data.number = this.filteredRoutePoints.length + 1
              this.routePoints.push(data)

              if (this.routePoints.length === 1) {
                this.setRequestPropertiesFromRoute(data)
              }
            } else {
              if (selectedRowIndex !== -1) {
                data.number = selectedRowIndex + 1

                const selectedRowIndexInFullList = this.routePoints.findIndex(routePoint => routePoint.id === this.selectedRow.id)
                this.routePoints.splice(selectedRowIndexInFullList, 0, data)

                for (let i = selectedRowIndex + 1; i < this.filteredRoutePoints.length; i++) {
                  this.filteredRoutePoints[i].number = i + 1
                  this.filteredRoutePoints[i].edited = true
                }

                if (selectedRowIndex === 0) {
                  this.setRequestPropertiesFromRoute(data)
                }
              }
            }
          }
        },
        header: 'Добавить точку маршрута?',
        propsConfig: {
          sourcedAddress: {
            type: 'address',
            label: 'Адрес'
          },
          projects: {
            label: 'Проект',
            type: 'objects',
            searchConfig: this.projectsFieldConfig,
            value: defaultProjects
          },
          plannedStartTime: {
            type: 'datetime',
            label: 'Плановое время подачи'
          },
          plannedEndTime: {
            type: 'datetime',
            label: 'Плановое время отбытия'
          },
          actualStartTime: {
            type: 'datetime',
            label: 'Фактическое время подачи'
          },
          actualEndTime: {
            type: 'datetime',
            label: 'Фактическое время отбытия'
          }
        },
        buttons: {
          yes: 'Подтвердить',
          cancel2: 'Отмена'
        }
      })
    },
    onEditRecord: function (row) {
      row = JSON.parse(JSON.stringify(row))
      const index = this.routePoints.findIndex(routePoint => routePoint.id === row.id)

      const readonlyDeliveryProperties = index === 0 && this.readonlyFirstRoutePointDelivery
      this.$d_ask({
        callback: (data, action) => {
          if (action === 'yes') {
            if (index !== -1) {
              row = Object.assign(row, data)
              row.edited = true
              this.routePoints.splice(index, 1, row)

              if (index === 0) {
                this.setRequestPropertiesFromRoute(row)
              }
            }
          }
        },
        header: 'Редактировать точку маршрута?',
        propsConfig: {
          sourcedAddress: {
            type: 'address',
            label: 'Адрес',
            value: row.sourcedAddress,
            readonly: readonlyDeliveryProperties
          },
          projects: {
            label: 'Проект',
            type: 'objects',
            searchConfig: this.projectsFieldConfig,
            value: row.projects
          },
          plannedStartTime: {
            type: 'datetime',
            label: 'Плановое время подачи',
            value: row.plannedStartTime,
            readonly: readonlyDeliveryProperties
          },
          plannedEndTime: {
            type: 'datetime',
            label: 'Плановое время отбытия',
            value: row.plannedEndTime
          },
          actualStartTime: {
            type: 'datetime',
            label: 'Фактическое время подачи',
            value: row.actualStartTime,
            readonly: this.actualTimesReadonly

          },
          actualEndTime: {
            type: 'datetime',
            label: 'Фактическое время отбытия',
            readonly: this.actualTimesReadonly,
            value: row.actualEndTime
          }
        },
        buttons: {
          yes: 'Подтвердить',
          cancel2: 'Отмена'
        }
      })
    },
    onChangePosition: function (row, dir) {
      const index = this.filteredRoutePoints.indexOf(row)
      if (index !== -1) {
        let shift
        if (dir === 'down') {
          if (this.filteredRoutePoints[index + 1] != null) {
            shift = 1
          }
        } else if (dir === 'up') {
          if (this.filteredRoutePoints[index - 1] != null) {
            shift = -1
          }
        }

        if (shift != null) {
          for (const key in row) {
            if (key !== 'number') {
              [this.filteredRoutePoints[index][key], this.filteredRoutePoints[index + shift][key]] = [this.filteredRoutePoints[index + shift][key], this.filteredRoutePoints[index][key]]
            }
          }
          this.filteredRoutePoints[index].edited = true
          this.filteredRoutePoints[index + shift].edited = true

          if (dir === 'up' && index === 1) {
            this.setRoutePropertiesFromRequest(this.filteredRoutePoints[0])
          }
        }
      }
    },
    setRoutePropertiesFromRequest: function (routePoint) {
      if (!this.readonlyFirstRoutePointDelivery) {
        routePoint.plannedStartTime = this.request.serviceTimeAgreed || this.request.serviceTimeRequired
        routePoint.sourcedAddress = this.request.address
      }
    },
    setRequestPropertiesFromRoute: function (routePoint) {
      if (!this.readonlyFirstRoutePointDelivery) {
        this.request.address = routePoint.sourcedAddress

        if (!this.requestProperties.serviceTimeAgreed.readonly && !this.requestProperties.serviceTimeRequired.readonly) {
          if (this.request.serviceTimeAgreed) {
            this.request.serviceTimeAgreed = routePoint.plannedStartTime
          } else {
            this.request.serviceTimeRequired = routePoint.plannedStartTime
          }
        } else if (!this.requestProperties.serviceTimeAgreed.readonly) {
          this.request.serviceTimeAgreed = routePoint.plannedStartTime
        } else if (!this.requestProperties.serviceTimeRequired.readonly) {
          this.request.serviceTimeRequired = routePoint.plannedStartTime
        }
      }
    },
    getProjects: function () {
      const params = [{
        param: 'status',
        type: 'listvalue',
        action: '!=',
        value: 'nonactive'
      }]
      return this.getPropertyValues('project', params)
    },
    getPropertyValues: function (propertyKey, params) {
      const encodedParams = encodeURIComponent(JSON.stringify(params))
      return axiosGet({
        url: '/service/obj/search?params=' + encodedParams + '&nameField=name&type=' + propertyKey + '&limit=1000&sort=name',
        onSuccess: (response) => response.data.result,
        onFailure: 'Ошибка получения значений параметра ' + propertyKey
      })
    },
    getTdStyle: function (col, row) {
      const outOfRequestInterval = (time) => {
        if (time && this.interval) {
          if (this.interval.start && time < this.interval.start || this.interval.end && time > this.interval.end) {
            return true
          }
        }
        return false
      }

      const index = this.filteredRoutePoints.findIndex(routePoint => routePoint.id === row.id)
      if (index !== -1) {
        const prevPoint = this.filteredRoutePoints[index - 1]
        if (col.name === 'plannedStartTime' && row.plannedStartTime) {
          if (prevPoint && prevPoint.plannedEndTime && row.plannedStartTime < prevPoint.plannedEndTime || prevPoint && prevPoint.plannedStartTime && row.plannedStartTime < prevPoint.plannedStartTime || outOfRequestInterval(row.plannedStartTime)) {
            return this.getColoredTdStyle('red', 'white')
          }
        }
        if (col.name === 'actualStartTime' && row.actualStartTime) {
          if (prevPoint && prevPoint.actualEndTime && row.actualStartTime < prevPoint.actualEndTime || prevPoint && prevPoint.actualStartTime && row.actualStartTime < prevPoint.actualStartTime || outOfRequestInterval(row.actualStartTime)) {
            return this.getColoredTdStyle('red', 'white')
          }
        }

        if (col.name === 'plannedEndTime' && row.plannedEndTime) {
          if (prevPoint && prevPoint.plannedEndTime && row.plannedEndTime < prevPoint.plannedEndTime || row.plannedStartTime && row.plannedStartTime > row.plannedEndTime || outOfRequestInterval(row.plannedEndTime)) {
            return this.getColoredTdStyle('red', 'white')
          }
        }
        if (col.name === 'actualEndTime' && row.actualEndTime) {
          if (prevPoint && prevPoint.actualEndTime && row.actualEndTime < prevPoint.actualEndTime || row.actualStartTime && row.actualStartTime > row.actualEndTime || outOfRequestInterval(row.actualEndTime)) {
            return this.getColoredTdStyle('red', 'white')
          }
        }
      }
    },
    getColoredTdStyle: function (bgColor, color, fontWeight = 500) {
      return `font-weight: ${fontWeight} !important;
          background-color: ${bgColor} !important;
          color: ${color} !important;
          border-bottom: solid #e0e0e0 1px;`
    }
  }
}

